/**
 * Client data source for <native-product-recommendations
 * data-client-source="recently-viewed">: reads the per-customer handle list
 * (written by the snippet's tracker on product pages), fetches each
 * product's /products/{handle}.js, maps it to the unified shape the shared
 * element renders, and hands the result to the element's render() — cards,
 * variant pills, slick and the mobile scroll row are all inherited from the
 * DSP-1603 pipeline. No XGen involvement anywhere.
 */
(function () {
  function unify(p) {
    var url = '/products/' + p.handle;
    var image = p.featured_image || (p.images && p.images[0]) || '';
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      url: url,
      vendor: p.vendor,
      type: p.type,
      available: p.available,
      price: p.price,
      compare_at_price: p.compare_at_price || 0,
      compareAtPrice: p.compare_at_price || p.price,
      options: (p.options || []).map(function (option) {
        return option && option.name ? option.name : option;
      }),
      collections: [],
      currency: {
        symbol: (window.theme && window.theme.currentCurrencySymbol) || '$',
        code: (window.theme && window.theme.currentCurrency) || ''
      },
      tags: p.tags || [],
      image: image,
      featured_image: image,
      images: [image],
      has_only_default_variant: p.variants.length === 1 && p.variants[0].title === 'Default Title',
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          url: url + '?variant=' + v.id,
          sku: v.sku,
          available: v.available,
          inStock: v.available,
          onSale: !!v.compare_at_price && v.compare_at_price > v.price,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          price: v.price,
          compare_at_price: v.compare_at_price || 0,
          compareAtPrice: v.compare_at_price || v.price
        };
      })
    };
  }

  function readEntries(el) {
    try {
      var list = JSON.parse(localStorage.getItem(el.getAttribute('data-storage-key')) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  // Deleted/unpublished products 404 once, then never again: their
  // handles are removed from storage.
  function pruneStale(el, staleHandles) {
    if (!staleHandles.length) return;
    try {
      var key = el.getAttribute('data-storage-key');
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (item) {
        return item && staleHandles.indexOf(item.handle) === -1;
      });
      localStorage.setItem(key, JSON.stringify(list));
    } catch (error) { /* storage unavailable */ }
  }

  function showEmptyState(el) {
    if (el.getAttribute('data-design-mode') === 'true') {
      var wrap = el.querySelector('[data-product-wrap]');
      if (wrap) {
        wrap.innerHTML = '<div style="padding: 12px 0; color: #666; font-size: 13px;">'
          + 'Recently viewed products appear here once the shopper has browsed some.</div>';
      }
      return;
    }
    el.style.display = 'none';
  }

  function hydrate(el) {
    var currentHandle = el.getAttribute('data-current-handle');
    var pageSize = Number(el.getAttribute('data-page-size')) || 10;
    var entries = readEntries(el).filter(function (item) {
      return item && item.handle && item.handle !== currentHandle;
    });
    if (!entries.length) {
      showEmptyState(el);
      return;
    }

    // Over-fetch a few so sold-out or deleted items don't shrink the row.
    var wanted = entries.slice(0, pageSize + 4);
    var stale = [];
    Promise.all(wanted.map(function (item) {
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (res) {
          if (!res.ok) {
            if (res.status === 404) stale.push(item.handle);
            return null;
          }
          return res.json();
        })
        .catch(function () { return null; });
    })).then(function (results) {
      pruneStale(el, stale);
      var products = results
        .filter(Boolean)
        .filter(function (p) { return p.available; })
        .map(unify)
        .slice(0, pageSize);
      if (!products.length) {
        showEmptyState(el);
        return;
      }
      el.render(products);

      // Presentment-currency sessions: /products/{handle}.js prices are in
      // the shop's base currency; reuse the theme's converter (the same
      // hook the xgen widgets used) when the active currency differs.
      if (typeof window.getProductPrices === 'function'
        && window.Shopify && window.Shopify.currency
        && window.theme && window.theme.currency
        && window.Shopify.currency.active !== window.theme.currency) {
        var variantIds = [];
        products.forEach(function (p) {
          p.variants.forEach(function (v) { variantIds.push(String(v.id)); });
        });
        if (variantIds.length) window.getProductPrices(variantIds);
      }
    });
  }

  function whenReady(el, attempts) {
    attempts = attempts == null ? 200 : attempts;
    var elementClass = window.customElements && customElements.get('native-product-recommendations');
    if (elementClass && el instanceof elementClass
      && window.renderProductCard && window.theme && window.theme.ProductCard
      && window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      hydrate(el);
      return;
    }
    if (attempts <= 0) return;
    setTimeout(function () { whenReady(el, attempts - 1); }, 50);
  }

  function boot() {
    document.querySelectorAll('native-product-recommendations[data-client-source="recently-viewed"]')
      .forEach(function (el) { whenReady(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
